import type { ReactNode } from 'react';

import { Link } from 'react-router';

import { GlassCard } from '@/lib/ui';
import { cn } from '@/lib/utils';
import { ROUTES } from '@/routes';

export type AuthTab = 'login' | 'register';

const authCardClass = 'space-y-6 border !bg-[var(--color-glass-bg)]';

interface AuthScreenShellProps {
  /** Omit to hide the Login / Sign Up tabs (e.g. for a signed-in user). */
  activeTab?: AuthTab;
  /** Wider card for multi-field registration. */
  maxWidthClass?: string;
  children: ReactNode;
}

export function AuthScreenShell({
  activeTab,
  maxWidthClass = 'max-w-md',
  children,
}: AuthScreenShellProps) {
  return (
    <div className={cn('w-full space-y-4', maxWidthClass)}>
      <div className="flex justify-center">
        <img src="/moveris-logo-dark.svg" alt="Moveris" className="h-10 w-auto" />
      </div>

      <GlassCard padding="lg" className={authCardClass}>
        {activeTab && (
          <div className="flex rounded-xl bg-white/5 p-1 ring-1 ring-white/10">
            <Link
              to={ROUTES.login}
              className={cn(
                'flex-1 rounded-lg py-2.5 text-center text-sm font-semibold transition-colors',
                activeTab === 'login'
                  ? 'bg-black/35 text-white shadow-sm'
                  : 'text-white/55 hover:text-white/85',
              )}
            >
              Login
            </Link>
            <Link
              to={ROUTES.register}
              className={cn(
                'flex-1 rounded-lg py-2.5 text-center text-sm font-semibold transition-colors',
                activeTab === 'register'
                  ? 'bg-black/35 text-white shadow-sm'
                  : 'text-white/55 hover:text-white/85',
              )}
            >
              Sign Up
            </Link>
          </div>
        )}

        {children}
      </GlassCard>
    </div>
  );
}
